module.exports = __webpack_public_path__ + "01462cfdb734371efae34dae5b4bea21.svg";